import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SinglePlayerGame } from "./components/SinglePlayer/SinglePlayerGame";
import Home from "./components/home";
import Settings from "./components/Settings";
import PlayerSetup from "./components/PlayerSetup";
import MultiPlayerLayout from './components/MultiPlayer/MultiPlayerLayout';
import HostEntryPoint from "./components/MultiPlayer/HostEntryPoint";
import JoinEntryPoint from "./components/MultiPlayer/JoinEntryPoint";
import { PublicGamesList } from "./components/MultiPlayer/PublicGamesList";
import GameScreen from "./components/MultiPlayer/GameScreen";
import SinglePlayerSettings from './components/SinglePlayer/SinglePlayerSettings';

import "./App.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/single-player/settings" element={<SinglePlayerSettings />} />
        <Route path="/single-player" element={<SinglePlayerGame />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/player-setup" element={<PlayerSetup />} />

        <Route path="/multi-player" element={<MultiPlayerLayout />}>
          <Route index element={<HostEntryPoint />} />
          <Route path="join" element={<JoinEntryPoint />} />
          <Route path="join/:hostId" element={<JoinEntryPoint />} />
          <Route path="public" element={
            <PublicGamesList 
                onJoin={(url) => {
                    // Navigate to join with the URL (which might be ws://...)
                    window.location.href = `/multi-player/join?url=${encodeURIComponent(url)}`;
                }} 
                onBack={() => window.history.back()} 
            />
          } />
          <Route path="game" element={<GameScreen />} />
        </Route>

      </Routes>
    </div>
  );
}

export default App; 